/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var _this = undefined;
    var util = MoyaContainer.get('core.util');
    var formElementIds = {
        TYPE_SELECT: '#type',
        CATEGORY_SELECT: '#category',
        SUBMIT: "#submitForm",
        TERMS: '#terms',
    };
    MoyaComponents.register('arango-crm.inquiry-form', function (el) {
        var config = {
            el: el,
            typeSelect: el.querySelector(formElementIds.TYPE_SELECT),
            categorySelect: el.querySelector(formElementIds.CATEGORY_SELECT),
            availableTypes: JSON.parse(el.dataset.inquiryTypes),
            termsEl: el.querySelector(formElementIds.TERMS),
            submitEl: el.querySelector(formElementIds.SUBMIT)
        };
        var inqueryForm = InquiryForm.create(config);
        inqueryForm.run();
        MoyaEventHandler.dispatch('arango-crm.inquiry-form', {
            inqueryForm: _this,
        });
    });
    var InquiryForm = /** @class */ (function () {
        function InquiryForm(config) {
            this.el = config.el;
            this.typeSelect = config.typeSelect;
            this.categorySelect = config.categorySelect;
            this.availableTypes = config.availableTypes;
            this.termsEl = config.termsEl;
            this.submitEl = config.submitEl;
        }
        InquiryForm.create = function (config) {
            return new InquiryForm(config);
        };
        InquiryForm.prototype.run = function () {
            var initialTypeValue = this.typeSelect.value;
            var initialCategoryValue = this.categorySelect.value;
            this.delegateEvents();
            this.initCheckboxes();
            this.populateTypeSelect();
            this.populateCategorySelect(this.typeSelect.value);
            this.setInitialValues(initialTypeValue, initialCategoryValue);
            this.handleSubmitAllowability(this.termsEl);
        };
        InquiryForm.prototype.delegateEvents = function () {
            var _this = this;
            util.delegate(this.el, 'change', formElementIds.TYPE_SELECT, function (e) {
                var typeSelect = e.delegateTarget;
                var typeId = typeSelect.value;
                _this.populateCategorySelect(typeId);
                _this.updateExtras(typeId);
                _this.updateQueryParams(formElementIds.TYPE_SELECT, typeId, e.isTrusted);
            });
            util.delegate(this.el, 'change', formElementIds.CATEGORY_SELECT, function (e) {
                var categorySelect = e.delegateTarget;
                _this.updateQueryParams(formElementIds.CATEGORY_SELECT, categorySelect.value, e.isTrusted);
            });
            util.delegate(this.el, 'click', formElementIds.SUBMIT, function (e) {
                setTimeout(function () {
                    e.delegateTarget.setAttribute('disabled', 'true');
                }, 1); // If we skip the timeout, the form isn't submitted 🤔
            });
            util.delegate(this.el, 'change', 'input[type=checkbox]', function (e) {
                markCheckbox(e.delegateTarget);
            });
            util.delegate(this.el, 'change', '#terms', function (e) {
                _this.handleSubmitAllowability(e.delegateTarget);
            });
        };
        InquiryForm.prototype.populateTypeSelect = function () {
            var _this = this;
            clearSelectOptions(this.typeSelect);
            var options = [
                createSelectOption('', 'Tegund')
            ];
            this.availableTypes.forEach(function (type) {
                options.push(createSelectOption(type.id, type.name));
            });
            options.forEach(function (option) {
                _this.typeSelect.add(option);
            });
        };
        InquiryForm.prototype.setInitialValues = function (typeValue, categoryValue) {
            if (!typeValue) {
                this.typeSelect.value = '';
                this.categorySelect.value = '';
                return;
            }
            this.typeSelect.value = typeValue;
            var event = new Event('change', { bubbles: true });
            this.typeSelect.dispatchEvent(event);
            if (categoryValue) {
                this.categorySelect.value = categoryValue;
            }
        };
        InquiryForm.prototype.populateCategorySelect = function (typeId) {
            var _this = this;
            clearSelectOptions(this.categorySelect);
            var options = [
                createSelectOption('', 'Flokkur')
            ];
            var type = this.getTypeById(typeId);
            if (type) {
                type.categories.forEach(function (category) {
                    var option = createSelectOption(category.id, category.name);
                    options.push(option);
                });
            }
            options.forEach(function (option) {
                _this.categorySelect.add(option);
            });
            this.categorySelect.disabled = this.categorySelect.options.length <= 1;
        };
        InquiryForm.prototype.updateExtras = function (typeId) {
            if (typeId === '') {
                return;
            }
            var selectedType = this.getTypeById(typeId);
            // Todo move
            this.el.querySelectorAll('div.elm.extra').forEach(function (elm) {
                var inputId = elm.querySelector('input').id;
                elm.style.display = selectedType.extras.indexOf(inputId) !== -1 ? 'block' : 'none';
            });
        };
        InquiryForm.prototype.updateQueryParams = function (param, value, isTrusted) {
            var urlParams = new URLSearchParams(window.location.search);
            urlParams.set(param.substring(1), value);
            if (param === formElementIds.TYPE_SELECT && isTrusted) {
                urlParams.delete(formElementIds.CATEGORY_SELECT.substring(1));
                if (!value) {
                    urlParams.delete(formElementIds.TYPE_SELECT.substring(1));
                }
            }
            window.history.replaceState('', '', '?' + urlParams.toString());
        };
        InquiryForm.prototype.getTypeById = function (typeId) {
            return this.availableTypes.find(function (type) {
                return type.id === typeId;
            });
        };
        InquiryForm.prototype.initCheckboxes = function () {
            var checkboxes = this.el.querySelectorAll('input[type=checkbox]');
            checkboxes.forEach(function (checkbox) {
                markCheckbox(checkbox);
            });
        };
        InquiryForm.prototype.handleSubmitAllowability = function (termsEl) {
            if (termsEl.checked) {
                this.submitEl.removeAttribute('disabled');
            }
            else {
                this.submitEl.setAttribute('disabled', 'true');
            }
        };
        return InquiryForm;
    }());
    function clearSelectOptions(el) {
        for (var i = el.options.length - 1; i >= 0; i--) {
            el.options.remove(i);
        }
    }
    function createSelectOption(value, text) {
        var option = document.createElement('option');
        option.value = value;
        option.text = text;
        return option;
    }
    function markCheckbox(el) {
        var closestElm = el.closest('.elm');
        closestElm.classList.add('hideCheck'); // We do this so if JS fails regular input is visible
        if (el.checked) {
            closestElm.classList.add('checked');
        }
        else {
            closestElm.classList.remove('checked');
        }
    }

}());
typeof tsBuild === 'function' && tsBuild();})();
